"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
require("./split-chart-menu-sk");
